import React, { Component } from 'react';
import classes from './TupleStackedMobile.scss';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { arrivalDuration } from '../../../utility';

// Airline
import AirlineWrapper from '../Wrappers/AirlineWrapper/AirlineWrapper';
import AirlineLogo from '../Airline/AirlineLogo/AirlineLogo';
import AirlineName from '../Airline/AirlineName/AirlineName';
import AirlineCode from '../Airline/AirlineCode/AirlineCode';

import AirlinePrice from '../Airline/AirlinePrice/AirlinePrice';

import AnimakitExpander from 'animakit-expander';
import TupleInner from '../../Flight/Tuple/TupleInner/TupleInner';

import * as flightActions from '../../../store/actions/index';
import * as fareRuleActions from '../../../store/actions/index';

class TupleStackedMobile extends Component {
    rules = null;
    priceCounter = null;
    rulesCounter = null;

    state = {
        tabIndex: 1,
        isTupleExpanded: false,
        showTooltip: true
      };

      componentWillMount() {
          setTimeout(() => {
            this.setState({
                showTooltip: false
            })
          }, 3000)
      }

      pricingHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState(prevState => {
          return {
            isTupleExpanded: !prevState.isTupleExpanded
          }
        });
      };

      switchTabHandler = (val) => {
        if (val === 2) {
            if(this.props.isIntFlight) {
                const params = new URLSearchParams(this.props.location.search);
                const sc = this.props.type === "onward" ? params.get('sc').split(',')[0] : params.get('sc').split(',')[1];
                const searchId = this.props.searchId;
                const flightId = this.props.type === "onward" ? params.get("flightIdCSV").split(',')[0] : params.get("flightIdCSV").split(',')[1];
                const fareRules = this.props.fareRules;
                let match = false;
                fareRules.forEach((element) => {
                    if (element.id === this.props.flightId) {
                      match = true;
                      this.rules = element.rules;
                    }
                })
                if (!match) {
                    const fareRuleParams = {
                      sc: sc,
                      flightIdCSV: flightId,
                      searchId: searchId
                    }
                    this.rulesCounter = this.props.rulesCounter;
                    this.props.onGetIntFareRules(fareRuleParams, flightId);
                }
            } else {
                const params = new URLSearchParams(this.props.location.search);
                const flightSchedule = this.props.type === "onward" ? this.props.flightScheduleOnward : this.props.flightScheduleReturn;
                const sc = this.props.type === "onward" ? params.get('sc').split(',')[0] : params.get('sc').split(',')[1];
                const flightId = this.props.type === "onward" ? params.get("flightIdCSV").split(',')[0] : params.get("flightIdCSV").split(',')[1];
                const supplierCode = sc;
                const searchId = this.props.searchId;
                const fareBasisCode = flightSchedule[0].FS[0].fbc;
                const airlineCode = flightSchedule[0].FS[0].ac;
                const resBookDesigCode = flightSchedule[0].FS[0].resBookDesigCode;
                const cabin = flightSchedule[0].FS[0].classtype;
                const fareRules = this.props.fareRules;
                let match = false;
                fareRules.forEach((element) => {
                    console.log(element.id);
                    console.log(flightId);
                if (element.id === flightId) {
                    match = true;
                    this.rules = element.rules;
                }
                })
                if (!match) {
                    const fareRuleParams =  {
                      flightIdCSV: flightId,
                      supplierCode: supplierCode,
                      searchId: searchId,
                      fareBasisCode: fareBasisCode,
                      AirlineCode: airlineCode,
                      resBookDesigCode: resBookDesigCode,
                      cabin: cabin
                    }
                    this.rulesCounter = this.props.rulesCounter;
                    this.props.onGetFareRules(fareRuleParams, flightId);
                }
            }
        }
        this.setState({
          tabIndex: val
        })
      }

    render() {
        const flightSchedule = this.props.type === "onward" ? this.props.flightScheduleOnward : this.props.flightScheduleReturn;
        const fareDetails = this.props.type === "onward" ? this.props.fareDetailsOnward : this.props.fareDetailsReturn;
        const tdu = this.props.type === "onward" ? this.props.tduOnward : this.props.tduReturn;

        const FS = flightSchedule[0].FS;
        const airlineCode = flightSchedule[0].FS[0].ac;
        const OD = flightSchedule[0];
        const TF = fareDetails.revisedFareDetails.tf;

        const totalStop = parseInt(OD.ts, 10);
        let stop = null;
        let stopCity = null;
        let stopOver = null;

        if (totalStop === 0) {
            stop = "Non Stop";
            stopOver = <span className={classes.Stopover}>{stop}</span>;
        } else if (totalStop >= 1) {
            stop = "Via ";
            stopCity = FS[0].loa;
            stopOver = (
                <span className={classes.Stopover}>
                    {stop} <span className="u-fontWeightMedium">{stopCity}</span>
                </span>
            );
        }
    
        console.log(flightSchedule[0].fid);
        const params = new URLSearchParams(this.props.location.search);
        const flightId = this.props.type === "onward" ? params.get("flightIdCSV").split(',')[0] : params.get("flightIdCSV").split(',')[1];
        if (this.props.rulesCounter > this.rulesCounter) {
          this.props.fareRules.forEach((element) => {
            if (element.id === flightId) {
              this.rules = element.rules;
            }
          });
        }
        const border = '1px dashed var(--color-border)';

        console.log(this.rules);

        return (
            <React.Fragment>
                <div className={classes.Container} 
                        onClick={this.pricingHandler} 
                        style={{
                            borderBottom: this.state.isTupleExpanded ? `${border}` : 'none',
                        }}>
                    <div className={classes.ContainerPrimary}>
                        <div style={{order: '6', display: 'flex', justifyContent: 'space-between', width: '100%', alignSelf: 'flex-end', marginTop: '1rem', alignItems: 'center'}}>
                            <AirlineWrapper style={{justifyContent: 'flex-start', order: '0', flex: 'none'}}>
                                    <AirlineLogo airlineCode={airlineCode} />
                                    <p className={classes.AirlineDetail}>
                                        <AirlineName FS={FS} airlineNames={this.props.airlineNames} />
                                        <span className={classes.Dash}>&nbsp;&ndash;&nbsp;</span><AirlineCode FS={FS} />
                                    </p>
                            </AirlineWrapper>
                            <span className={classes.Change} onClick={(e) => { e.stopPropagation(); this.props.onHideReturnFlights()}}>Details</span>
                            <div style={{display: this.props.location.pathname.trim('').includes('/reviews') ? 'none' : 'block'}} className={classes.VerticalDivider}>&nbsp;</div>
                            <div style={{lineHeight: '2rem', display: this.props.location.pathname.trim('').includes('/reviews') ? 'none' : 'block'}} className={classes.Box1}>
                                    <AirlinePrice tf={TF} />
                            </div>
                        </div>
                        <div className={classes.SolidBorder}></div>
                        <div style={{width: '100%', marginBottom: '3px'}} className={`u-flex justify-content-between align-items-center`}>
                            <span className={`u-fontSize16 u-textColorDark u-fontWeightRegular`}>{FS[0].dd}</span> 
                            {tdu ? <span className={`u-textColorLight u-fontSize13`}>{tdu.substring(0, 2) + "h " + tdu.substring(3, 5) + "m"}</span> : null}
                            <span className={`u-fontSize16 u-textColorDark u-fontWeightRegular`}>{arrivalDuration(flightSchedule)}</span>
                        </div>
                        <div style={{width: '100%'}} className={`u-flex justify-content-between align-items-center`}>
                            <span className={`u-fontSize13 u-fontWeightRegular u-textColorNormal u-textAlignLeft u-width100`}>{this.props.cityNames[this.props.type === "onward" ? this.props.isIntFlight ? this.props.idac : this.props.origin : this.props.isIntFlight ? this.props.iaac : this.props.destination]}</span>
                            {stopOver}
                            <span className={`u-fontSize13 u-fontWeightRegular u-textColorNormal u-textAlignRight u-width100`}>{this.props.cityNames[this.props.type === "onward" ? this.props.isIntFlight ? this.props.iaac : this.props.destination : this.props.isIntFlight ? this.props.idac : this.props.origin]}</span>
                        </div>
                        <div style={{width: '100%', marginBottom: 'auto'}} className={`u-flex justify-content-between align-items-center`}>
                            <span className={`u-fontWeightMedium u-textColorNormal u-fontSize13`}>{this.props.type === "onward" ? this.props.origin : this.props.destination}</span>
                            <span className={`u-fontWeightMedium u-textColorNormal u-fontSize13`}>{this.props.type === "onward" ? this.props.destination : this.props.origin}</span>
                        </div>
                    </div>
                </div>
                <AnimakitExpander
                    expanded={this.state.isTupleExpanded}
                    duration={400}
                    align="top"
                >
                    <TupleInner
                        flightSchedule={flightSchedule}
                        fareDetails={fareDetails}
                        fareRules={this.rules}
                        clubbed={this.props.clubbed}
                        switchTab={this.switchTabHandler}
                        cityNames={this.props.cityNames}
                        airlineNames={this.props.airlineNames}
                        airportNames={this.props.airportNames}
                        tabIndex={this.state.tabIndex}
                    />
                </AnimakitExpander>
            </React.Fragment>
        )
    }
};

const mapStateToProps = state => {
    return {
        flightScheduleOnward: state.farePrice.flightScheduleOneWay,
        flightScheduleReturn: state.farePrice.flightScheduleRoundTrip,
        fareDetailsOnward: state.farePrice.fareSummaryOneWay,
        fareDetailsReturn: state.farePrice.fareSummaryRoundTrip,
        tduOnward: state.farePrice.tduOnward,
        loaOnward: state.farePrice.loaOnward,
        tduReturn: state.farePrice.tduReturn,
        loaReturn: state.farePrice.loaReturn,
        fareRules: state.fareRules.fareRules,
        farePrice: state.farePrice.farePrice,
        airlineNames: state.farePrice.generalData.data.airlineNames,    
        cityNames: state.farePrice.generalData.data.cityNames,
        airportNames: state.farePrice.generalData.data.airportNames,
        searchId: state.farePrice.generalData.searchId,
        origin: state.farePrice.generalData.data.org,
        destination: state.farePrice.generalData.data.dest,
        rulesCounter: state.fareRules.counter,
        priceCounter: state.farePrice.counter,
        isIntFlight: state.farePrice.generalData.countryCodes.origin !== 'IN' || state.farePrice.generalData.countryCodes.dest !== 'IN'
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onHideReturnFlights: () => dispatch(flightActions.hideReturnFlights()), 
        onGetFareRules: (fareRuleParams, flightId) => dispatch(fareRuleActions.getFareRules(fareRuleParams, flightId)),
        onGetIntFareRules: (fareRuleParams, flightId) => dispatch(fareRuleActions.getIntFareRules(fareRuleParams, flightId))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TupleStackedMobile));


// WEBPACK FOOTER //
// ./src/components/Flight/TupleStackedMobile/TupleStackedMobile.js